import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { User, Mail, Phone, Bell } from 'lucide-react';

export function GuestWaitlistDialog({
  open, onOpenChange,
  guestName, setGuestName,
  guestEmail, setGuestEmail,
  guestPhone, setGuestPhone,
  loading, onSubmit,
}) {
  const canSubmit = guestName.trim().length >= 2 && /\S+@\S+\.\S+/.test(guestEmail);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl flex items-center gap-2">
            <Bell className="h-5 w-5 text-[#D4AF37]" />
            Join the waitlist
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 mt-2">
          <p className="text-sm text-stone-500">
            We'll email (and text, if you add a number) the moment this slot opens up.
          </p>

          <div className="space-y-2">
            <Label htmlFor="wl-guest-name">Your Name *</Label>
            <div className="relative">
              <User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-stone-400" />
              <Input
                id="wl-guest-name"
                value={guestName}
                onChange={(e) => setGuestName(e.target.value)}
                placeholder="Enter your name"
                className="input-zuriya pl-10"
                data-testid="waitlist-guest-name-input"
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="wl-guest-email">Email Address *</Label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-stone-400" />
              <Input
                id="wl-guest-email"
                type="email"
                value={guestEmail}
                onChange={(e) => setGuestEmail(e.target.value)}
                placeholder="you@example.com"
                className="input-zuriya pl-10"
                data-testid="waitlist-guest-email-input"
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="wl-guest-phone">Phone (optional, for SMS alerts)</Label>
            <div className="relative">
              <Phone className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-stone-400" />
              <Input
                id="wl-guest-phone"
                type="tel"
                value={guestPhone}
                onChange={(e) => setGuestPhone(e.target.value)}
                placeholder="+44 7700 900123"
                className="input-zuriya pl-10"
                data-testid="waitlist-guest-phone-input"
              />
            </div>
          </div>

          <Button
            onClick={onSubmit}
            disabled={!canSubmit || loading}
            className="w-full btn-primary h-12 rounded-lg gap-2"
            data-testid="waitlist-guest-submit-btn"
          >
            <Bell className="h-4 w-4" />
            {loading ? 'Joining...' : 'Join Waitlist'}
          </Button>

          <p className="text-[11px] text-stone-400 text-center">
            By joining, you agree to receive notifications if the slot opens up. No payment required.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
